import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { catchError, map, of, switchMap } from 'rxjs';

import { ProfileService } from '../../core/services/profile.service';
import { selectStoreId } from '../auth/auth.selectors';
import { ProfileActions } from './profile.actions';

export const loadProfile$ = createEffect(
  (actions$ = inject(Actions), profile = inject(ProfileService)) =>
    actions$.pipe(
      ofType(ProfileActions.loadProfile),
      switchMap(() =>
        profile.getProfile().pipe(
          map((p) => ProfileActions.loadProfileSuccess({ profile: p })),
          catchError((err) =>
            of(ProfileActions.loadProfileFailure({ error: err?.message ?? 'Load failed' })),
          ),
        ),
      ),
    ),
  { functional: true },
);

export const loadCreditInfo$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store), profile = inject(ProfileService)) =>
    actions$.pipe(
      ofType(ProfileActions.loadCreditInfo),
      concatLatestFrom(() => store.select(selectStoreId)),
      switchMap(([, storeId]) => {
        if (!storeId) {
          return of(ProfileActions.loadCreditInfoFailure({ error: 'Missing store id' }));
        }
        return profile.getCreditInfo(storeId).pipe(
          map((credit) => ProfileActions.loadCreditInfoSuccess({ credit })),
          catchError((err) =>
            of(
              ProfileActions.loadCreditInfoFailure({
                error: err?.error?.message ?? err?.message ?? 'Credit load failed',
              }),
            ),
          ),
        );
      }),
    ),
  { functional: true },
);
